import { apiSlice } from "../../app/api/apiSlice"
import { generateFormatedURL } from "../../utils/urlFormatter"

export const ProjectApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getProjectById: builder.query({
            query: (id) => `/Project/${id}`,
        }),

        getProjectListing: builder.query({
            query: (args) => `/Project`.concat(generateFormatedURL(args)),
        }),

        createProject: builder.mutation({
            query: (body) => ({
                url: '/Project',
                method: 'POST',
                body: { ...body },
            })
        }),

        updateProject: builder.mutation({
            query: (body) => ({
                url: `/Project/${body?.id}`,
                method: 'PUT',
                body: { ...body },
            })
        }),

        getLocationListing: builder.query({
            query: (id) => `/Project/${id}/Location`,
        }),

        createLocation: builder.mutation({
            query: (body) => ({
                url: `/Project/${body?.projectId}/Location`,
                method: 'POST',
                body: { ...body },
            }),
        }),

        updateLocation: builder.mutation({
            query: (body) => ({
                url: `/Project/${body?.projectId}/Location/${body?.id}`,
                method: 'PUT',
                body: { ...body },
            })
        }),

        getProjectDDL: builder.query<any, void>({
            query: () => "Project/DropdownList"
        }),
    })
})

export const {
    useLazyGetProjectByIdQuery,
    useLazyGetProjectListingQuery,
    useCreateProjectMutation,
    useUpdateProjectMutation,
    useLazyGetLocationListingQuery,
    useCreateLocationMutation,
    useUpdateLocationMutation,
    useLazyGetProjectDDLQuery
} = ProjectApiSlice  